import BreadCrumbs from 'components/breadcrumbs'
import CustomButton from 'components/Buttons/CustomButton'
import PMBPagination from 'components/PMBPagination'
import PMBSelect from 'components/PMBSelect'
import PMBTabSwitcher from 'components/PMBTabSwitcher'
import { TableComponent as DataTable } from 'components/TableComponent'
import { Can } from 'context/Acl'
import { getWarehouse } from 'features/public-views/manageStock/API/manageStockAction'
import { actionOptions, getActionWording, useDebounce } from 'helpers'
import moment from 'moment-timezone'
import { useEffect, useMemo, useRef, useState } from 'react'
import {
  ChevronDown,
  ChevronUp,
  Download,
  Filter,
  Send,
  X,
} from 'react-feather'
import { PMBDateRangePicker } from 'components/PMBNewDatePicker'
import { useIntl } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Badge, Card, CardBody, Col, Collapse, Row } from 'reactstrap'
import './styles.css'

import LihatDetail from 'components/Icons/LihatDetail'
import PMBProgressBarExportFile from 'components/PMBProgressBarExportFile'
import PMBSearchInputGroup from 'components/PMBSearchInputGroup'
import { formatDatePMB } from 'utils/formatDate'
import {
  URL_DETAIL_TRANSACTION,
  URL_FORM_TRANSFER_INVENTORY,
  URL_TRANSFER_INVENTORY,
} from 'utils/pathUrl'
import { BUSINESS_TRANSFER_INVENTORY, MANAGE } from 'utils/subjectActions'
import { handleDownloadExcel } from './downloadTransferInventory'
import {
  useFetchInventoryTransferQuery,
  useFetchInventoryReasonTypeQuery,
  useLazyFetchInventoryTransferQuery,
} from './transferInventoryApiSlice'
import { setFetchOption } from './transferInventorySlice'
import { P } from 'components'

const TransferInventory = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const intl = useIntl()
  const { tag } = useSelector((s) => s.transferInventory)

  const { profile } = useSelector((s) => s.dashboard)
  let [page, setPage] = useState({ page: tag.page })
  const savedFilters =
    JSON?.parse(localStorage?.getItem('transferInventoryFilters')) || {}
  const [currentPage, setCurrentPage] = useState(savedFilters?.page ?? 0)
  const [rowsPerPage, setRowsPerPage] = useState(savedFilters?.size ?? 10)
  const [selectedRow, setSelectedRow] = useState(null)
  // const [activeTab, setActiveTab] = useState('in')
  const [sortColumn, setSortColumn] = useState(
    savedFilters?.sortColumn ?? 'createdAt',
  )
  const [sortDirection, setSortDirection] = useState(
    savedFilters?.sortDirection ?? 'desc',
  )
  const date = new Date()
  const y = date.getFullYear()
  const m = date.getMonth()

  const lastDay = moment().format('YYYY-MM-DD')
  const firstDay = moment().subtract(3, 'months').format('YYYY-MM-DD')

  const initialDate = savedFilters?.selectedDate
    ? savedFilters.selectedDate
    : [firstDay, lastDay]
  const [selectedDate, setSelectedDate] = useState(initialDate)
  const defaultDateRangeRef = useRef(initialDate)
  const [searchInput, setSearchInput] = useState(
    savedFilters?.searchInput ?? '',
  )
  const [search, setSearch] = useState(savedFilters?.search ?? '')
  const [isDownload, setIsDownload] = useState(false)
  const [firstRows, setFirstRows] = useState(0)
  const [totalRows, setTotalRows] = useState(0)

  const [isFilterOpen, setIsFilterOpen] = useState(
    savedFilters?.isFilterOpen ?? false,
  )

  const { warehouses } = useSelector((s) => s.manageStock)

  const filterParams = {
    search: search ?? '',
    sortby: sortColumn,
    sortdir: sortDirection,
    type: tag?.type,
    ...(tag?.receiverwarehouseId !== undefined && {
      receiverwarehouseId: tag?.receiverwarehouseId,
    }),
    ...(tag?.senderwarehouseId !== undefined && {
      senderwarehouseId: tag?.senderwarehouseId,
    }),
    ...(tag?.status && {
      status: tag?.status,
    }),
    start: moment(selectedDate[0]).format('YYYY-MM-DD'),
    end: moment(selectedDate[1]).format('YYYY-MM-DD'),
    ...(tag?.action && {
      action: tag?.action,
    }),
    ...(tag?.subaction && {
      subaction: tag?.subaction,
    }),
  }

  const { data, isLoading, isFetching, refetch } =
    useFetchInventoryTransferQuery(
      {
        ...filterParams,
        page: currentPage ?? 0,
        size: rowsPerPage ?? 10,
      },
      { skip: !page },
    )

  const [triggerFetchForDownload] = useLazyFetchInventoryTransferQuery()

  const { data: reasonTypeData } = useFetchInventoryReasonTypeQuery({ page: 0, size: 10 })

  const allActionOptions = useMemo(() => {
    const list = [
      { label: 'Semua Keterangan', value: undefined, subTypes: [] },
      { label: 'Proses', value: 'TRANSFORM', subTypes: [] },
      { label: 'Kirim', value: 'TRANSFER', subTypes: [] },
      { label: 'Tambah', value: 'CREATE', subTypes: [] },
      { label: 'Transaksi', value: 'TRADE', subTypes: [] },
      { label: 'Hapus', value: 'DELETED', subTypes: [] },
      { label: 'Pisah', value: 'SPLIT', subTypes: [] },
      { label: 'Gabung', value: 'MERGE', subTypes: [] },
    ]

    if (reasonTypeData?.manualDeletionTypes) {
      reasonTypeData.manualDeletionTypes.forEach((item) => {
        const existing = list.find((opt) => opt.value === item.type)
        if (existing) {
          existing.subTypes = item.subTypes || []
          if (item.label) {
            existing.label = item.label === 'Dibuang' ? 'Hapus' : item.label
          }
        } else {
          if (item.type !== 'DELETED' && item.type !== 'SELL') {
            list.push({
              label: item.label,
              value: item.type,
              subTypes: item.subTypes || [],
            })
          }
        }
      })
    }

    if (reasonTypeData?.adjustmentReasons) {
      reasonTypeData.adjustmentReasons.forEach((item) => {
        list.push({
          label: item.label,
          value: item.type,
          subTypes: item.subTypes || [],
        })
      })
    }

    return list
  }, [reasonTypeData])

  const selectedActionOpt = useMemo(() => {
    return allActionOptions.find((opt) => opt.value === tag.action)
  }, [allActionOptions, tag.action])

  const subactionOptions = useMemo(() => {
    if (!selectedActionOpt?.subTypes || selectedActionOpt.subTypes.length === 0) return []
    return [
      { label: 'Semua Detail', value: undefined },
      ...selectedActionOpt.subTypes.map((sub) => ({
        label: sub.label || sub.reason || sub.name || sub.description,
        value: sub.type || sub.code || sub.id,
      }))
    ]
  }, [selectedActionOpt])

  const statusOptions = [
    { label: 'Semua Status', value: 1 },
    {
      label: 'Menunggu konfirmasi penerima',
      value: 2,
    },
    { label: 'Diterima', value: 3 },
    { label: 'Ditolak', value: 4 },
  ]

  const columns = [
    {
      name: <span>Tanggal</span>,
      sortable: true,
      sortField: 'createdAt',
      cell: (row) => formatDatePMB(row?.createdAt, row?.createdAt),
      selector: (row) => row?.createdAt,
      minWidth: '150px',
    },
    {
      name: <span>Nomor Transfer</span>,
      minWidth: '180px',
      cell: (row) => row?.transferNumber || '-',
      selector: (row) => row?.transferNumber,
    },
    {
      name: <span>Nama Barang</span>,
      grow: 2,
      minWidth: '150px',
      cell: (row) => (
        <div className="d-flex flex-column py-2">
          <span className="flex-row">
            {row?.labelOuter ??
              row?.warehousetransferitem?.[0]?.label ??
              row?.warehousetransferitem?.[0]?.inventory?.item?.nameItem}
          </span>
          {!row?.labelOuter && (
            <span className="text-primary">
              {intl.formatNumber(
                row?.warehousetransferitem?.[0]?.amount ??
                  row?.warehousetransferitem?.[0]?.inventory?.amount,
                {
                  useGrouping: 'always',
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 2,
                },
              )}{' '}
              {row?.warehousetransferitem?.[0]?.unit ??
                row?.warehousetransferitem?.[0]?.inventory?.unit ??
                row?.warehousetransferitem?.[0]?.inventory?.item?.unit}
            </span>
          )}

          {row?.labelOuter ? (
            <>
              {row?.warehousetransferitem?.length && (
                <div className="bg-gray-100 badge rounded-pill my-1">
                  <span className="text-dark fw-medium">
                    +{' '}
                    {intl.formatNumber(row?.warehousetransferitem?.length, {
                      useGrouping: 'always',
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0,
                    })}{' '}
                    inventori lainnya
                  </span>
                </div>
              )}
            </>
          ) : (
            <>
              {row?.warehousetransferitem?.length > 1 && (
                <div className="bg-gray-100 badge rounded-pill my-1">
                  <span className="text-dark fw-medium">
                    +{' '}
                    {intl.formatNumber(row?.warehousetransferitem?.length - 1, {
                      useGrouping: 'always',
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0,
                    })}{' '}
                    inventori lainnya
                  </span>
                </div>
              )}
            </>
          )}
        </div>
      ),
      selector: (row) => {
        const name =
          row?.labelOuter ??
          row?.warehousetransferitem?.[0]?.label ??
          row?.warehousetransferitem?.[0]?.inventory?.item?.nameItem
        return name || '-'
      },
    },
    {
      name: <span>Gudang Pengirim</span>,
      minWidth: '250px',
      grow: 2,
      sortable: true,
      sortField: 'warehousesender.name',
      cell: (row) => {
        return (
          <div
            className="d-flex flex-column gap-1 py-2"
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-start',
            }}
          >
            <span>{row?.warehousesender?.name || '-'}</span>
            <span>{row?.sender?.name || '-'}</span>
          </div>
        )
      },
      selector: (row) =>
        `${row?.warehousesender?.name ?? ''} ${row?.sender?.name ?? ''}`,
    },
    {
      name: <span>Gudang Tujuan</span>,
      grow: 2,
      sortable: true,
      sortField: 'warehousereceiver.name',
      cell: (row) => {
        return (
          <div
            className="d-flex flex-column gap-1 py-2"
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-start',
            }}
          >
            <span>{row?.warehousereceiver?.name}</span>
            <span>{row?.receiver?.name}</span>
          </div>
        )
      },
      selector: (row) =>
        `${row?.warehousereceiver?.name ?? ''} ${row?.receiver?.name ?? ''}`,
      minWidth: '250px',
    },
    {
      name: <span>Status</span>,
      minWidth: '150px',
      grow: 2,
      cell: (row) => {
        if (row?.approvedAt) {
          return (
            <div
              className="badge rounded-pill bg-success-50 text-success-700 px-2"
              style={{
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                textAlign: 'center',
                maxWidth: '100%',
              }}
            >
              Diterima
            </div>
          )
        } else if (row?.rejectedAt) {
          return (
            <div
              className="badge rounded-pill bg-danger-50 text-danger-700 px-2"
              style={{
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                textAlign: 'center',
                maxWidth: '100%',
              }}
            >
              Ditolak
            </div>
          )
        } else {
          return (
            <div
              className="badge rounded-pill bg-warning-50 text-warning-700 px-2"
              style={{
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                textAlign: 'center',
                maxWidth: '100%',
              }}
            >
              Menunggu konfirmasi penerima
            </div>
          )
        }
      },
      selector: (row) => {
        if (row?.approvedAt) {
          return 'Diterima'
        } else if (row?.rejectedAt) {
          return 'Ditolak'
        } else {
          return 'Menunggu konfirmasi penerima'
        }
      },
    },
    {
      name: <span>Keterangan</span>,
      minWidth: '150px',
      cell: (row) => {
        return (
          <div className="d-flex flex-column gap-2">
            <div
              className="bg-gray-100 badge rounded-pill px-2"
              style={{
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                textAlign: 'center',
                maxWidth: '100%',
              }}
            >
              <span className="text-dark fw-medium text-capitalize">
                {(() => {
                  const matchingOption = allActionOptions.find((opt) => {
                    if (opt.parentAction) {
                      return opt.parentAction === row?.action && opt.value === row?.subaction
                    }
                    return opt.value === row?.action && !row?.subaction
                  })
                  return matchingOption ? matchingOption.label : getActionWording(row?.action, row)
                })()}
              </span>
            </div>
            {row?.escrowpaymentId ? (
              <div
                className="bg-primary-50 badge rounded-pill px-2"
                style={{
                  whiteSpace: 'normal',
                  wordBreak: 'break-word',
                  textAlign: 'center',
                  maxWidth: '100%',
                  cursor: 'pointer',
                }}
                onClick={() =>
                  navigate(
                    `${URL_DETAIL_TRANSACTION}/${row?.escrowpaymentId}?type=${tag?.type === 'in' ? 'BUY' : 'SELL'}`,
                  )
                }
              >
                <span className="text-primary fw-medium text-capitalize">
                  {row?.poNumber}
                </span>
              </div>
            ) : (
              <></>
            )}
          </div>
        )
      },
      selector: (row) => {
        const matchingOption = allActionOptions.find((opt) => {
          if (opt.parentAction) {
            return opt.parentAction === row?.action && opt.value === row?.subaction
          }
          return opt.value === row?.action && !row?.subaction
        })
        return matchingOption ? matchingOption.label : getActionWording(row?.action, row)
      },
    },
    {
      name: '',
      minWidth: '80px',
      cell: (row) => {
        return (
          <div className="d-flex gap-3" data-testid={`tf-inv-table-row-${row?.id}`}>
            <LihatDetail
              onClick={() => {
                navigate(
                  `${URL_TRANSFER_INVENTORY}/${row?.id}?type=${tag?.type}`,
                )
                // dispatch(toggleSidebar())
                // setSelectedRow(row)
              }}
              id={row?.id}
              data-testid={`tf-inv-row-detail-${row?.id}`}
            />
          </div>
        )
      },
    },
  ]

  const handleSort = (column, direction) => {
    setSortColumn(column.sortField)
    setSortDirection(direction)
  }

  const handleTabChange = (tabKey) => {
    // setActiveTab(tabKey)
    setCurrentPage(0)
    setRowsPerPage(10)
    dispatch(
      setFetchOption({
        page: 0,
        sortby: sortColumn,
        sortdir: sortDirection,
        type: tabKey,
        size: tag?.size,
      }),
    )
  }

  const handleFilterChange = (value, type) => {
    if (type === 'action') {
      dispatch(
        setFetchOption({
          page: 0,
          action: value,
          subaction: undefined,
        }),
      )
    } else {
      dispatch(
        setFetchOption({
          page: 0,
          [type]: value,
        }),
      )
    }
  }

  const debouncedSearch = useDebounce((value) => {
    setCurrentPage(0)
    setRowsPerPage(10)
    setSearch(value)
    refetch()
  }, 600)

  const onHandleSearchChange = (value) => {
    setSearchInput(value ?? '')
    debouncedSearch(value ?? '')
  }

  const handleKeyDown = (e) => {
    if (e.key === ' ' && search.length === 0) {
      e.preventDefault()
    }
  }

  const tabs = [
    { key: 'in', label: 'Inventori Masuk' },
    { key: 'out', label: 'Inventori Keluar' },
  ]

  useEffect(() => {
    dispatch(getWarehouse({ isForFilter: true, isAdd: true }))
  }, [])

  useEffect(() => {
    if (savedFilters) {
      const {
        selectedDate,
        senderwarehouseId,
        receiverwarehouseId,
        status,
        action,
        subaction,
      } = savedFilters

      const isSenderWarehouseValid = warehouses?.newData?.some(
        (w) => w?.id === senderwarehouseId,
      )
      const isReceiverWarehouseValid = warehouses?.newData?.some(
        (w) => w?.id === receiverwarehouseId,
      )

      const isActionValid = allActionOptions?.some((a) => a.value === action)

      setSelectedDate(selectedDate || [firstDay, lastDay])
      // Restore UI states
      setCurrentPage(savedFilters?.page ?? 0)
      setRowsPerPage(savedFilters?.size ?? 10)
      setSortColumn(savedFilters?.sortColumn ?? 'createdAt')
      setSortDirection(savedFilters?.sortDirection ?? 'desc')
      setSearchInput(savedFilters?.searchInput ?? '')
      setSearch(savedFilters?.search ?? '')
      setIsFilterOpen(savedFilters?.isFilterOpen ?? false)

      dispatch(
        setFetchOption({
          senderwarehouseId: isSenderWarehouseValid
            ? senderwarehouseId
            : undefined,
          receiverwarehouseId: isReceiverWarehouseValid
            ? receiverwarehouseId
            : undefined,
          status: status || 1,
          action: isActionValid ? action : undefined,
          subaction: isActionValid ? subaction : undefined,
          page: savedFilters?.page ?? 0,
          size: savedFilters?.size ?? 10,
        }),
      )
    }
  }, [warehouses, allActionOptions])

  useEffect(() => {
    const filtersToSave = {
      selectedDate: selectedDate,
      senderwarehouseId: tag?.senderwarehouseId,
      receiverwarehouseId: tag?.receiverwarehouseId,
      status: tag?.status,
      action: tag?.action,
      subaction: tag?.subaction,
      // UI + table states
      searchInput: searchInput,
      search: search,
      page: currentPage,
      size: rowsPerPage,
      sortColumn: sortColumn,
      sortDirection: sortDirection,
      isFilterOpen: isFilterOpen,
    }
    localStorage.setItem(
      'transferInventoryFilters',
      JSON?.stringify(filtersToSave),
    )
  }, [
    selectedDate,
    tag.senderwarehouseId,
    tag.receiverwarehouseId,
    tag.status,
    tag.action,
    tag.subaction,
    searchInput,
    search,
    currentPage,
    rowsPerPage,
    sortColumn,
    sortDirection,
    isFilterOpen,
  ])

  useEffect(() => {
    refetch()
  }, [tag.type, refetch])

  const isDateFilterChanged = useMemo(() => {
    const defaultRange = defaultDateRangeRef.current || []
    if (!selectedDate || selectedDate.length < 2) return false
    if (!defaultRange || defaultRange.length < 2) return false

    return selectedDate.some((date, idx) => {
      const defaultDate = defaultRange[idx]
      if (!date || !defaultDate) return false
      return date !== defaultDate
    })
  }, [selectedDate])

  const activeFilterCount = useMemo(() => {
    let count = 0
    if (isDateFilterChanged) count++
    if (tag.receiverwarehouseId !== undefined) count++
    if (tag.senderwarehouseId !== undefined) count++
    if (tag.status && tag.status !== 1) count++
    if (search && search?.toString()?.trim()?.length > 0) count++
    // For UI editability, count search input as active filter too
    if (tag.action && tag.action !== undefined) count++
    if (tag.subaction && tag.subaction !== undefined) count++
    return count
  }, [
    isDateFilterChanged,
    tag.receiverwarehouseId,
    tag.senderwarehouseId,
    tag.status,
    tag.action,
    tag.subaction,
    search,
  ])

  const handleClearFilters = () => {
    const defaultRange = defaultDateRangeRef.current || [firstDay, lastDay]
    setSelectedDate(defaultRange)
    // Reset search field
    setSearchInput('')
    setSearch('')
    // Reset local paging and sort to default
    setCurrentPage(0)
    setRowsPerPage(10)
    setSortColumn('createdAt')
    setSortDirection('desc')

    dispatch(
      setFetchOption({
        senderwarehouseId: undefined,
        receiverwarehouseId: undefined,
        status: 1,
        action: undefined,
        subaction: undefined,
        page: 0,
        size: 10,
        start: defaultRange[0],
        end: defaultRange[1],
      }),
    )
  }

  return (
    <div className="w-100 px-3">
      <PMBProgressBarExportFile
        isDialogShow={isDownload}
        firstRows={firstRows}
        totalRows={totalRows}
        onCancel={() => setIsDownload(false)}
      />
      <div className="d-flex align-items-start gap-2 pt-3">
        <BreadCrumbs breadCrumbActive={'Transfer Inventori'} />
      </div>
      <Card className="border-0 shadow-sm">
        <CardBody>
          <DataTable
            columns={columns}
            data={data?.items}
            progressPending={isLoading || isFetching}
            persistTableHead
            sortServer
            defaultSortFieldId={1}
            defaultSortAsc={false}
            sortIcon={<ChevronDown />}
            onSort={handleSort}
            pagination
            paginationServer
            paginationComponent={(props) => (
              <PMBPagination
                rowCount={data?.totalItems || 0}
                currentPage={currentPage}
                rowsPerPage={rowsPerPage}
                setCurrentPage={setCurrentPage}
                setRowsPerPage={setRowsPerPage}
                props={props}
              />
            )}
            subHeader
            subHeaderComponent={
              <div className="w-100">
                <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap">
                  <h5>Transfer Inventori</h5>
                  <Can I={MANAGE} this={BUSINESS_TRANSFER_INVENTORY}>
                    <CustomButton
                      onClick={() => navigate(URL_FORM_TRANSFER_INVENTORY)}
                      color="primary"
                      testId="tf-inv-add-button"
                    >
                      <Send size={15} /> Kirim Inventori
                    </CustomButton>
                  </Can>
                </div>
                <div className="d-flex justify-content-between align-items-center flex-wrap mb-0">
                  <PMBTabSwitcher
                    activeTab={tag?.type}
                    tabs={tabs}
                    onTabChange={handleTabChange}
                    testId="tf-inv-tab"
                  />
                  <div className="d-flex align-items-center gap-2">
                    <div className="d-flex align-items-center gap-2 w-100">
                      {activeFilterCount > 0 && (
                        <CustomButton
                          onClick={handleClearFilters}
                          color="danger"
                          className="d-flex align-items-center justify-content-center"
                          style={{
                            width: '40px',
                            height: '40px',
                            padding: 0,
                            minWidth: '40px',
                          }}
                        >
                          <X size={16} />
                        </CustomButton>
                      )}
                      <CustomButton
                        color="primary"
                        outline
                        className="flex-grow-1 position-relative"
                        onClick={() => setIsFilterOpen((prev) => !prev)}
                      >
                        <div className="d-flex align-items-center gap-2 justify-content-center">
                          <Filter size={16} />
                          <span>Filter</span>
                          {activeFilterCount > 0 && (
                            <Badge
                              color="danger"
                              pill
                              style={{
                                position: 'absolute',
                                top: '-5px',
                                right: '-5px',
                                fontSize: '10px',
                              }}
                            >
                              {activeFilterCount}
                            </Badge>
                          )}
                          {isFilterOpen ? (
                            <ChevronUp size={16} className="ml-2" />
                          ) : (
                            <ChevronDown size={16} className="ml-2" />
                          )}
                        </div>
                      </CustomButton>
                    </div>
                    <CustomButton
                      onClick={async () =>
                        handleDownloadExcel(
                          // Refetch all rows matching the filters, not just this page
                          await triggerFetchForDownload({
                            ...filterParams,
                            page: 0,
                            size: data?.totalItems || rowsPerPage || 10,
                          }).unwrap(),
                          setIsDownload,
                          setFirstRows,
                          setTotalRows,
                          columns,
                          tag?.type,
                          tag,
                          statusOptions,
                          warehouses?.newData,
                        )
                      }
                      color="primary"
                      outline
                      className="d-flex align-items-center justify-content-center gap-2"
                    >
                      <Download size={15} />
                      <P>Download</P>
                    </CustomButton>
                  </div>
                </div>
                <Collapse isOpen={isFilterOpen}>
                  <div
                    className="border rounded p-3 bg-light mb-3 filter-collapse"
                    style={{
                      width: '100%',
                      transition: 'all 0.3s ease-in-out',
                      opacity: isFilterOpen ? 1 : 0,
                      transform: isFilterOpen
                        ? 'translateY(0)'
                        : 'translateY(-10px)',
                    }}
                  >
                    <Row className="g-2">
                      <Col xs={12} md={4} lg={3}>
                        <p className="mb-2">Cari</p>
                        <PMBSearchInputGroup
                          // label={'Cari'}
                          value={searchInput}
                          placeholder="Cari..."
                          onChange={(e) => onHandleSearchChange(e.target.value)}
                          maxWidth="100%"
                          onKeyDown={handleKeyDown}
                          testId="tf-inv-search-input"
                        />
                      </Col>
                      <Col xs={12} md="auto" lg="auto">
                        <PMBDateRangePicker
                          style={{ width: '100%', maxWidth: '100%' }}
                          value={selectedDate ?? []}
                          onChange={(dates) => {
                            if (dates?.length === 2) {
                              setSelectedDate(dates)
                              dispatch(
                                setFetchOption({
                                  start: dates[0],
                                  end: dates[1],
                                }),
                              )
                            }
                          }}
                          onClear={() => {
                            setSelectedDate([firstDay, lastDay])
                            dispatch(
                              setFetchOption({
                                start: firstDay,
                                end: lastDay,
                              }),
                            )
                          }}
                          format="yyyy-mm-dd"
                          clearMode="callback"
                        />
                      </Col>
                      <Col xs={12} md={4} lg={3}>
                        <p className="mb-2">Gudang Pengirim</p>
                        <PMBSelect
                          style={{ width: '100%' }}
                          placeholder="Semua Gudang"
                          options={warehouses?.newData}
                          onChange={(e) =>
                            handleFilterChange(e?.id, 'senderwarehouseId')
                          }
                          value={warehouses?.newData?.find(
                            (e) => e.id === tag.senderwarehouseId,
                          )}
                          menuPortalTarget={
                            typeof window !== 'undefined' ? document.body : null
                          }
                          testId="tf-inv-filter-senderwarehouseId-select"
                        />
                      </Col>

                      <Col xs={12} md={4} lg={3}>
                        <p className="mb-2">Gudang Tujuan</p>
                        <PMBSelect
                          style={{ width: '100%' }}
                          placeholder="Semua Gudang"
                          options={warehouses?.newData}
                          onChange={(e) =>
                            handleFilterChange(e?.id, 'receiverwarehouseId')
                          }
                          value={warehouses?.newData?.find(
                            (e) => e.id === tag.receiverwarehouseId,
                          )}
                          menuPortalTarget={
                            typeof window !== 'undefined' ? document.body : null
                          }
                          testId="tf-inv-filter-receiverwarehouseId-select"
                        />
                      </Col>

                      <Col xs={12} md={4} lg={3}>
                        <p className="mb-2">Status</p>
                        <PMBSelect
                          style={{ width: '100%' }}
                          placeholder="Semua Status"
                          options={statusOptions}
                          onChange={(e) =>
                            handleFilterChange(e?.value, 'status')
                          }
                          value={statusOptions?.find(
                            (e) => e.value === tag.status,
                          )}
                          menuPortalTarget={
                            typeof window !== 'undefined' ? document.body : null
                          }
                          testId="tf-inv-filter-status-select"
                        />
                      </Col>

                      <Col xs={12} md={4} lg={3}>
                        <p className="mb-2">Keterangan</p>
                        <PMBSelect
                          style={{ width: '100%' }}
                          placeholder="Semua Keterangan"
                          options={allActionOptions}
                          onChange={(e) =>
                            handleFilterChange(e?.value, 'action')
                          }
                          value={allActionOptions?.find(
                            (e) => e.value === tag.action
                          )}
                          menuPortalTarget={
                            typeof window !== 'undefined' ? document.body : null
                          }
                          testId="tf-inv-filter-action-select"
                        />
                      </Col>

                      {subactionOptions.length > 0 && (
                        <Col xs={12} md={4} lg={3}>
                          <p className="mb-2">Detail Keterangan</p>
                          <PMBSelect
                            style={{ width: '100%' }}
                            placeholder="Semua Detail"
                            options={subactionOptions}
                            onChange={(e) =>
                              handleFilterChange(e?.value, 'subaction')
                            }
                            value={subactionOptions?.find(
                              (e) => e.value === tag.subaction
                            )}
                            menuPortalTarget={
                              typeof window !== 'undefined' ? document.body : null
                            }
                            testId="tf-inv-filter-subaction-select"
                          />
                        </Col>
                      )}
                    </Row>
                  </div>
                </Collapse>
              </div>
            }
          />
        </CardBody>
      </Card>
    </div>
  )
}

export default TransferInventory
